import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { MUTATION_KEYS } from 'constants/common';
import { SESSION_STORAGE } from 'constants/storage';
import { BillingService } from 'services/billing';
import { type CreatePatientPackPayload, type PackCheckout } from 'types/billing';
import { setInSessionStorage } from 'utils/storage';

export const useCreatePack = (): UseMutationResult<
  PackCheckout,
  AxiosError,
  CreatePatientPackPayload
> => {
  const { getValues } = useFormContext();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  return useMutation<PackCheckout, AxiosError, CreatePatientPackPayload>({
    mutationKey: [MUTATION_KEYS.CREATE_SESSION_PACK],
    mutationFn: async (body: CreatePatientPackPayload) =>
      BillingService.createPatientPack({
        ...body,
        specialitiesBookable: Number(getValues('specialityBooked')),
      }),
    onSuccess: checkout => {
      setInSessionStorage(SESSION_STORAGE.CHECKOUT_APPOINTMENT_DATA, getValues());
      window.location.href = checkout.url;
    },
    onError: () => {
      toast.error(t('AppointmentsReserve.Steps.payment.error'));
    },
  });
};
